module.exports = __webpack_public_path__ + "static/img/bg_city.5de76d5e.jpg";